/**
 * Enumeration of all pages
 */
export enum Page {
    /** Represents the {@link CanvasComponent} */
    Canvas = "canvas",
    DragonHead = "dragonhead",
    /** Represents the {@link KeyboardComponent} */
    Keyboard = "keyboard",
    /** Represents the {@link KeypadComponent} */
    KeypadServerDoor = "keypad-server-door",

    /** Represents the {@link KeypadComponent} */
    KeypadGameSafe = "keypad-game-safe",

    /** Represents the {@link KeypadComponent} */
    KeypadWebSafe = "keypad-web-safe",
    Keypad = "keypad",
    Inventory = "Inventory",
    Interactive = "Interactive",
}
